/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


/** Keys used in endpoint URL query string */
export enum RequestKeys {
  PAGE = 'p',
  REQUEST = 'req',
}

/** Values for RequestKeys.PAGE key in endpoint URL query string */
export enum Pages {
  LANDING = 'landing',
  VIEW_STUDY = 'viewStudy',
}

/** Values for RequestKeys.REQUEST key in endpoint URL query string */
export enum Requests {
  /** Landing page requests */
  FETCH_STUDIES = 'fetchStudies',
  NEW_STUDY = 'newStudy',
  EDIT_STUDY = 'editStudy',
  DELETE_STUDY = 'deleteStudy',

  /** View Study page requests */
  FETCH_EXPERIMENTS = 'fetchExperiments',
  EDIT_EXPERIMENT = 'editExperiment',
  IMPORT_SENSORS = 'importSensors',
  FETCH_PLOT_DATA = 'fetchPlotData',
  GENERATE_GREEN_LINES = 'generateGreenLines',
  COMMONIZE_GREEN_LINES = 'commonizeGreenLines',
  SMOOTH_GREEN_LINES = 'smoothGreenLines',
  SYMMETRIZE_GREEN_LINES = 'symmetrizeGreenLines',
  GET_SENSOR_ID_TO_NAME = 'getSensorIdToName',
  GET_DATASET_ID_TO_DATA = 'getDatasetIdToData',
  GET_GREENLINE_ID_TO_PROPERTIES = 'getGreenlineIdToProperties',
  DOWNLOAD_DATA_SET = 'downloadDataSet',

  GENERATE_BLUE_LINES = 'generateBlueLines',
  CHECK_IF_OBJECTS_VALID_FOR_BLUE_LINE_GENERATION = 'checkIfObjectsValidForBlueLineGeneration',

  GENERATE_VIOLATIONS = 'generateViolations',

  CHECK_IF_DATASETS_EXIST = 'checkIfDatasetsExist',
}

/** Values for socket message types */
export enum SocketMessageTypes {
  ADD_STUDY = 'addStudy',
  UPDATE_STUDY = 'updateStudy',
  DELETE_STUDY = 'deleteStudy',
  UPDATE_EXPERIMENT = 'updateExperiment',

  SET_GREENLINE_ID_TO_PROPERTIES = 'setGreenlineIdToProperties',
  SET_REDLINE_SYNC_STATE = 'setRedlineSyncState',
  SET_GREENLINE_ID_TO_PLOT_DATA = 'setGreenlineIdToPlotData',

  SET_GREENLINE_ID_TO_RUN_STATE = 'setGreenlineIdToRunState',
  SET_SENSOR_ID_TO_BLUELINE_RUN_STATE = 'setSensorIdToBlueLineRunState',
  SET_SENSOR_ID_TO_VIOLATIONS_RUN_STATE = 'setSensorIdToViolationsRunState',
}

/** Socket messages in Sensing System Architecture Design app */
export type SocketMessage = {
  type: SocketMessageTypes,

  /** Data returned depends on the message type */
  data: any
}

/** The states that a Green Line Data Set can be in */
export enum GreenLineDataSetStates {
  /** The data set has been created but not yet configured or generated */
  NEW = 'New',

  /** The data set is configured but not yet generated */
  PENDING = 'Pending',

  /** The data set is queued for generation */
  PROCESSING = 'Processing',

  /** The data set is currently being generated */
  GENERATING = 'Generating',

  /** The data set is generated and is ready to view */
  COMPLETE = 'Complete',

  /** The data set has encountered an error during generation */
  ERROR = 'Error',
}
